import axios from 'axios'
import { sendDatadogError } from '../../../../services/datadog'

// ACTION NAMES
export const SET_ONBOARDING_CHECKS = 'SET_ONBOARDING_CHECKS'
export const SET_ORGANIZATION_HAS_SCORES = 'SET_ORGANIZATION_HAS_SCORES'
export const SET_ORGANIZATION_HAS_CAMPAIGNS = 'SET_ORGANIZATION_HAS_CAMPAIGNS'

// ACTIONS

export function loadOnboardingChecks(cb) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id

    const token = getState().get('engagement').auth.get('JWT')

    return axios({
      method: 'get',
      url: `/organizations/${orgId}/onboarding_checks/`,
      headers: {
        Authorization: token,
        Accept: 'application/json'
      }
    })
      .then((res) => {
        const { results } = res.data
        dispatch({
          type: SET_ONBOARDING_CHECKS,
          data: results
        })

        if (cb) cb(res.data)
      })
      .catch((err) => {
        sendDatadogError('Could not get onboarding checks.', 'warning', err.response)
        if (cb) cb(false)
      })
  }
}

export function setCompletedStep(stepId, status) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id

    const token = getState().get('engagement').auth.get('JWT')

    return axios({
      method: 'post',
      url: `/organizations/${orgId}/set_onboarding_check/?step_id=${stepId}&status=${status}`,
      headers: {
        Authorization: token,
        Accept: 'application/json'
      }
    })
      .then(() => {
        dispatch(loadOnboardingChecks())
      })
      .catch((err) => {
        sendDatadogError('Could not get onboarding checks.', 'warning', err.response)
      })
  }
}

export function checkOrgHasScores() {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id

    const token = getState().get('engagement').auth.get('JWT')

    return axios({
      method: 'get',
      url: `/organizations/${orgId}/has_scores/`,
      headers: {
        Authorization: token,
        Accept: 'application/json'
      }
    })
      .then((res) => {
        const { data } = res
        dispatch({
          type: SET_ORGANIZATION_HAS_SCORES,
          data: data.result
        })
      })
      .catch((err) => {
        sendDatadogError('Could not get has scores.', 'warning', err.response)
      })
  }
}

export function checkOrgHasCampaigns() {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id

    const token = getState().get('engagement').auth.get('JWT')

    return axios({
      method: 'get',
      url: `/organizations/${orgId}/has_campaigns/`,
      headers: {
        Authorization: token,
        Accept: 'application/json'
      }
    })
      .then((res) => {
        const { data } = res
        dispatch({
          type: SET_ORGANIZATION_HAS_CAMPAIGNS,
          data
        })
      })
      .catch((err) => {
        sendDatadogError('Could not get has campaigns.', 'warning', err.response)
      })
  }
}
